import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'; 


const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    root:{
      marginTop:70
  },
    paper: {
      maxWidth: 300,
      align:'center',
      margin:'3%',
      padding:'10%',
      backgroundColor: '#C1E5DD',
      flex: 1,
      maxHeight: 300
  
    },
    item:
    {
        width:'33%'
    },
    h:
    {
        margin:'3%',
        color:'#009688',
    },
    imag:
      {  
          fit: 'contain',
          maxHeight:'75%',
          maxWidth:'60%',
          flexShrink: 1,
          margin:'auto'
      }
  }));

  
export default function Researcher (props)
{   
    const classes = useStyles();
    const [op,setOp]=React.useState(1);

    const onMouseEnterHandler=  () => {
            setOp(0.2);
    }
    const onMouseLeaveHandler=  () => {
        setOp(1);
     }
     const onMouseClickHandler=  () => {
      console.log('it does work');
      window.location.href = props.webpage;
   }
  

      return(
        <Grid justify="center" item className={classes.item}>
            <Paper className={classes.paper} > 
             <img src={props.name}  
                className={classes.imag} 
                  style={{opacity:op}} 
                  onMouseEnter={onMouseEnterHandler} 
                  onMouseLeave={onMouseLeaveHandler} 
                  onClick={onMouseClickHandler}></img>
                <Typography style={{marginTop:20}}>
                <span style={{fontWeight:'bold'}}> {props.fullName} </span> <br/>
                    {props.startdate}
                </Typography>
            </Paper>
         </Grid>);
  }
